import { type MotifComponent, type MotifComponentProps, m } from '../../motif';
import { tertiaryBlockVars } from './Block.palette';

export const snapBlockPrimaryVars: MotifComponentProps<MotifComponent.BLOCK> = {
  ...tertiaryBlockVars,
  '--block-title-de-emphasized-color': m('--neutral-v500'),
} as const;
